import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { Text, View } from 'react-native';

interface Props {
  quantity: number;
}

export const OrderItemQuantityBox: React.FC<Props> = ({ quantity }) => {
  const [styles] = useStyles();

  return (
    <View style={styles.quantityBox}>
      <Text style={[TYPOGRAPHY.small, FONTS.primarySemiBold]}>{quantity}</Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  quantityBox: {
    alignItems: 'center',
    backgroundColor: theme.colors.background,
    borderColor: theme.colors.stroke,
    borderRadius: 4,
    borderWidth: 1,
    color: theme.colors.primary,
    fontSize: theme.fontSizes.small,
    height: 24,
    justifyContent: 'center',
    maxWidth: 40,
    minWidth: 24,
  },
}));
